import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AnimatedContainerWrapper = styled.div<{ isVisible: boolean }>`
  opacity: ${({ isVisible }) => (isVisible ? "1" : "0")};
`;

export const AnimatedChild = styled.div<{ delay: string }>`
  opacity: 0;
  animation: ${fadeIn} 0.3s ease forwards;
  animation-delay: ${({ delay }) => delay};
`;
